import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { payrollEndpoints } from "@/features/payroll/api/endpoints";
import type {
  PayrollBatchFilter,
  PayrollBatchListItemDto,
} from "@/features/payroll/api/dto";

/**
 * Liste paginée des paies de masse (`POST /PayrollBatches/all`, guide v4.1
 * §6.11). Un marchand ne voit que ses paies ; le back-office les voit toutes.
 * Lecture authentifiée : `mutateData` en queryFn, la requête reste une query
 * TanStack (cache, invalidation via `payrollBatchCacheKeys`).
 */
export const usePayrollBatches = (
  params: ListRequest<PayrollBatchFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.PAYROLL_BATCHES_LIST(params),
    queryFn: () =>
      mutateData({
        url: payrollEndpoints.payrollBatches.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<PayrollBatchListItemDto>>,
    enabled,
  });
